import { render, staticRenderFns } from "./ShareCandidate.vue?vue&type=template&id=4f297044&"
import script from "./ShareCandidate.vue?vue&type=script&lang=js&"
export * from "./ShareCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports